import { findPageDescriptorById } from './util.find-page-descriptor-by-id.js';

function findCourseDescriptorFromParents(state, pageDescriptor) {
  if (!pageDescriptor) {
    return void 0;
  }
  if (pageDescriptor.type === "Course") {
    return pageDescriptor;
  }
  if (pageDescriptor.parentId !== void 0) {
    return findCourseDescriptorFromParents(
      state,
      findPageDescriptorById(state, pageDescriptor.parentId)
    );
  }
  return void 0;
}

export { findCourseDescriptorFromParents };
//# sourceMappingURL=descriptor.course-descriptors-from-parent.js.map
